import { useState } from 'react';
import styled from '@emotion/styled';

import { PostTableOfContentsListItem } from '@/components/page/blog/PostTableOfContentsListItem';
import { captionLarge } from '@/styles/typography';

export interface PostTableOfContentsProps {
  tocData: SanityBlogPostTocDataType;
}

export interface SanityBlogPostTocDataType {
  count: number;
  headingKeys: Array<string>;
  headingIds: Array<string>;
  headingStrings: Array<string>;
}

export const PostTableOfContents = ({ tocData }) => {
  const [activeItem, setActiveItem] = useState('');
  const handleSetActiveItem = (item) => {
    setActiveItem(item);
  };

  return (
    <ContentContainer>
      <PostToCHeading>Contents</PostToCHeading>
      <PostToCList>
        {tocData.headingStrings.map((string, idx) => {
          const headingId = tocData.headingIds[idx];
          const headingKey = tocData.headingKeys[idx];

          return (
            <PostTableOfContentsListItem
              key={`${headingKey}-${headingId}`}
              handleSetActiveItem={handleSetActiveItem}
              headingKey={headingKey}
              headingId={headingId}
              headingString={string}
              isActive={activeItem === headingId}
            />
          );
        })}
      </PostToCList>
    </ContentContainer>
  );
};

const ContentContainer = styled.div`
  margin-top: var(--spacing-medium);

  display: flex;
  flex-direction: column;
  gap: var(--spacing-medium);
`;

const PostToCHeading = styled.h2`
  ${captionLarge};
`;

const PostToCList = styled.ol`
  white-space: normal;

  display: flex;
  flex-direction: column;
  gap: var(--spacing-xx-small);

  li {
    margin-bottom: var(--spacing-xx-small);
  }
`;
